
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_ENDPOINTS = {
  Login: `${API_BASE_URL}/login/verify`,
  getsites: `${API_BASE_URL}/sites`,
  getstatistic:`${API_BASE_URL}/sites/##siteid##/stats`,
  getareas: `${API_BASE_URL}/parking-areas`,
  RequestCode: `${API_BASE_URL}/login/request`,
  RequestLogout: `${API_BASE_URL}/logout`,
  RefreshToken: `${API_BASE_URL}/refresh-token`,
  getusers: `${API_BASE_URL}/sites/##siteid##/users`,
  getusersarea: `${API_BASE_URL}/parking-areas/##areaid##/users`,
  checkTimerSeconds: 600, //10min
  refreshIntervalInSeconds: 43200, //12h
  // remote camera tunnels (platform admins; called with the admin token)
  remoteRequest: `${API_BASE_URL}/ezadmin/remote/request`,
  remoteHeartbeat: `${API_BASE_URL}/ezadmin/remote/heartbeat`,
  remoteStop: `${API_BASE_URL}/ezadmin/remote/stop`,
  createCategory: `${API_BASE_URL}/sites/##siteid##/categories`,
  whatsNew: `${API_BASE_URL}/me/whats-new`,
  getHourPassings: `${API_BASE_URL}/sites/##siteid##/stats/passings`,
  getGates: `${API_BASE_URL}/sites/##siteid##/parking-areas/##areaid##/gates`,
  updateGate: `${API_BASE_URL}/sites/##siteid##/parking-areas/##areaid##/gates/##gateid##`,
  updateGateCamera: `${API_BASE_URL}/sites/##siteid##/parking-areas/##areaid##/gates/##gateid##/cameras/##cameraid##`,
  patchGateProximity: `${API_BASE_URL}/sites/##siteid##/parking-areas/##areaid##/gates/##gateid##/proximity`,
  wireguardClients: `${API_BASE_URL}/wireguard-clients`,
  getStatsInsights: `${API_BASE_URL}/sites/##siteid##/stats/insights`,
  exportPassingsCsv: `${API_BASE_URL}/sites/##siteid##/stats/passings/export`,
  getSpecialPlates: `${API_BASE_URL}/sites/##siteid##/special-plates`,
  updateSpecialPlateRule: `${API_BASE_URL}/sites/##siteid##/special-plates/##ruleid##`,

  // Admin portal — session endpoints take the normal login token (authFetch),
  // everything else the admin token (adminFetch / adminJson).
  adminSessionStatus: `${API_BASE_URL}/admin/session/status`,
  adminSessionRequest: `${API_BASE_URL}/admin/session/request`,
  adminSessionVerify: `${API_BASE_URL}/admin/session/verify`,
  adminMe: `${API_BASE_URL}/admin/me`,
  adminSites: `${API_BASE_URL}/admin/sites`,
  adminSite: `${API_BASE_URL}/admin/sites/##siteid##`,
  adminArea: `${API_BASE_URL}/admin/areas/##areaid##`,
  adminGate: `${API_BASE_URL}/admin/gates/##gateid##`,
  adminCamera: `${API_BASE_URL}/admin/cameras/##cameraid##`,
  adminPartners: `${API_BASE_URL}/admin/partners`,
  adminWireguardClients: `${API_BASE_URL}/admin/wireguard-clients`,
  adminDeleteImpact: `${API_BASE_URL}/admin/##type##/##id##/delete-impact`,
  adminDelete: `${API_BASE_URL}/admin/##type##/##id##`,
  adminWireguardClient: `${API_BASE_URL}/admin/wireguard-clients/##id##`,
  adminWizard: `${API_BASE_URL}/admin/wizard`,
  adminHealth: `${API_BASE_URL}/admin/health`,
  adminWizardValidate: `${API_BASE_URL}/admin/wizard/validate`,
  adminWizardTestCamera: `${API_BASE_URL}/admin/wizard/test-camera`,
};

export default API_ENDPOINTS;
